import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ComboBoxOption } from 'src/app/models/combo-box-option';
import { ProductDistribution } from 'src/app/models/register/product/product-distribution';
import { ProductDistributionDetail } from 'src/app/models/register/product/product-distribution-detail';
import { FileService } from 'src/app/services/file/file.service';
import { ProductService } from 'src/app/services/product/product.service';
import { WorkBook, WorkSheet } from 'xlsx';

@Component({
  selector: 'distribution-restrict',
  templateUrl: './distribution-restrict.component.html',
  styleUrls: ['./distribution-restrict.component.scss'],
})
export class DistributionRestrictComponent implements OnChanges, DoCheck, OnInit {
  printBatchRestrictedPrefix: string = '';

  @ViewChild('deliveryWayRestrictInput')
  deliveryWayRestrictInput: FileUpload | null = null;

  printBatchRestrictedPrefixOptions: ComboBoxOption[] = [];

  @Input()
  InputdeliveryWayRestrict: ProductDistribution[] = [];

  deliveryWayRestrict: any[] = [];

  @Input()
  isDownload?: boolean;

  @Input()
  quantity: string = '0';

  @Input()
  isConfirmed: boolean = false;

  @Input()
  isLoading: boolean = false;

  minDate: Date = new Date();

  @Output()
  changed = new EventEmitter<any>();

  @Output()
  changeTotal = new EventEmitter<any>();

  @Input()
  totalValue: number = 0;

  currentTotal: number = 0;

  selectedDistribution!: ProductDistribution[];

  private differ: IterableDiffer<ProductDistribution>;

  public download(): void {
    let fileUrl = `/assets/docs/${
      this.isDownload ? 'modelo_importacao_download_restrito' : 'modelo_importacao_estoque_restrito'
    }.xlsx`;
    window.location.href = fileUrl;
  }

  constructor(
    private fileService: FileService,
    private productService: ProductService,
    private confirmationService: ConfirmationService,
    private differs: IterableDiffers,
    private cdr: ChangeDetectorRef
  ) {
    this.differ = this.differs.find([]).create<ProductDistribution>();
  }
  ngOnInit(): void {
    this.currentTotal = this.totalValue;
    if (this.InputdeliveryWayRestrict.length > 0) {
      this.InputdeliveryWayRestrict.forEach(item => {
        this.deliveryWayRestrict.push(item);
      });
    }
  }

  handleParsedData(data: { branchCode: string; quantity: number }[]) {
    console.log('Dados recebidos da planilha:', data);
    //this.deliveryWayRestrict.filter((item: any) => !item.remove);
    data.forEach(({ branchCode, quantity }) => {
      this.productService
        .combobox('branches', branchCode)
        .then((resultData: any): void => {
          if (resultData?.length) {
            let index = this.deliveryWayRestrict.findIndex(
              item => item.detail.id === resultData[0].value
            );

            if (index === -1) {
              this.deliveryWayRestrict.push({
                detail: {
                  id: resultData[0].value,
                  label: resultData[0].label,
                },
                quantity,
                checked: true,
              });
            } else {
              this.InputdeliveryWayRestrict[index] = {
                detail: {
                  id: resultData[0].value,
                  label: resultData[0].label,
                },
                quantity,
                checked: true,
              };
            }
          }
        })
        .finally(() => this.onChangeData());
    });
  }

  public deleteSelectedProductionItens(event: any) {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: `Deseja remover ${this.selectedDistribution.length} linhas da distribuição?`,
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.selectedDistribution.forEach(item => {
          var idx = this.deliveryWayRestrict.findIndex(deliveryItem => deliveryItem.id === item.id);
          console.log('current_item', idx);
          this.setOnRemoveItem(idx);
        });
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  public removeDeliveryWayRestrict(event: any, item: any, i: number): void {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: 'Deseja realmente remover <strong>' + item.detail.label + '</strong>?',
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.setOnRemoveItem(i);
        // this.deliveryWayRestrict.splice(i, 1);
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  private setOnRemoveItem(index: number) {
    this.deliveryWayRestrict[index].remove = true;
    this.onChangeData();

    this.cdr.detectChanges();
  }

  public filterDeliveryWayRestrict(event: any): void {
    this.productService
      .combobox('branches', event.query) //
      .then(
        (data: any): void =>
          (this.printBatchRestrictedPrefixOptions = data.filter(
            (
              item: any
            ): boolean => //
              !this.deliveryWayRestrict.some(
                (distribution: any): boolean => distribution['id'] === item['value']
              )
          ))
      );
  }

  public addDeliveryWayRestrict(event: any): void {
    this.deliveryWayRestrict.push({
      detail: {
        id: event.value,
        label: event.label,
      } as ProductDistributionDetail,
      quantity: 0,
      checked: true,
    } as ProductDistribution);

    setTimeout((): void => {
      this.printBatchRestrictedPrefix = '';
      const input: HTMLInputElement = document.getElementById(
        'print-batch-restricted-prefix3'
      )! as HTMLInputElement;
      input.focus();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes', changes);
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.deliveryWayRestrict);
    if (change) {
      // há mudanças internas no array
      change.forEachAddedItem(record => {
        // console.log('Item adicionado:', record.item);
      });
      change.forEachRemovedItem(record => {
        // console.log('Item removido:', record.item);
      });

      this.onChangeData();

      this.cdr.detectChanges();
    }
  }

  get Itens() {
    return this.deliveryWayRestrict.filter((item: any) => !item.remove);
  }

  onChangeData(): void {
    console.log(this.deliveryWayRestrict);
    this.changed.emit(this.deliveryWayRestrict);
  }

  onChangeTotal(): void {
    console.log('changed this total');
    this.changeTotal.emit({ type: 'P', total: this.currentTotal });
  }
}
